import { defaultCatalogueSortingvalues } from "../../types"
import { catalogueValueTypes } from "../../types/types"

export const defaultCatalogueInputValues:catalogueValueTypes = {
  caseToPieceLabel:{
    "name": "caseToPieceLabel",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      "string"
    ]
  },

  ptrVisibility:{
    "name": "ptrVisibility",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      "string"
    ]
  },
  catalogueSortingType:{
    "name": "catalogueSortingType",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "To enable custom sorting type",
    "possibleVals": [
      "1",
      "2",
      "3"
    ]
  },
  couponFilterVisibility:{
    "name": "couponFilterVisibility",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true, false
    ]
  },
  showScanButton:{
    "name": "showScanButton",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true, false
    ]
  },
  multiVariantOrder:{
    "name": "multiVariantOrder",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true, false
    ]
  },

  bundleCouponVisibility:{
    "name": "bundleCouponVisibility",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true, false
    ]
  },
  caseToPieceVisibility:{
    "name": "caseToPieceVisibility",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true, false
    ]
  },
  unnatiCatalogueSorting:{
    "name": "unnatiCatalogueSorting",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true, false
    ]
  },
    schemeLabel:{
        "name": "schemeLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "string"
        ]
    },
    otherPtrLabel:{
        "name": "otherPtrLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "string"
        ]
    },
    similarProductLabel:{
        "name": "similarProductLabel",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
            "string"
        ]
    },
    dummyProductImgUpload:{
        "name": "dummyProductImgUpload",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    catalogueSequenceType:{
        "name": "catalogueSequenceType",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    multiVariantSortingOption:{
        "name": "multiVariantSortingOption",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    multiVariantGroupingOption:{
      "name": "multiVariantGroupingOption",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
    incentiveFlow:{
    "name": "incentiveFlow",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "Tells what format should be used and corresponding handlebar helper runs. Helpers : CapitalizeText , upperCaseValue",
    "possibleVals": [
      true, false
    ]
    },

  missedSchemeVisibility: {
    "name": "missedSchemeVisibility",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "Tells what format should be used and corresponding handlebar helper runs. Helpers : CapitalizeText , upperCaseValue",
    "possibleVals": [
      true, false
    ]
  },
  showBilledSkuLabel: {
    "name": "showBilledSkuLabel",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "Tells what format should be used and corresponding handlebar helper runs. Helpers : CapitalizeText , upperCaseValue",
    "possibleVals": [
      true, false
    ]
    },
    skuDescriptionFormatter:{
      "name": "skuDescriptionFormatter",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "Tells what format should be used and corresponding handlebar helper runs. Helpers : CapitalizeText , upperCaseValue",
      "possibleVals": [
        "captialize",
        "noFormatter",
        "uppercase",
        "lowercase"
      ]
    },
    mrpLabel:{
      "name": "mrpLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config in mrp span in ProductMrpTemplate or MultiUOM_ProductMrpTemplate template",
      "possibleVals": [
        "string"
      ]
    },
    showFreeProductLabel:{
      "name": "showFreeProductLabel",
      "type": "boolean",
      "value": true,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        true,
        false
      ]
    },
    schemeVisibility:{
      "name": "schemeVisibility",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        true,
        false
      ]
    },
    crossSellLabel:{
      "name": "crossSellLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "CROSS-SELL",
        "MUST TRY"
      ]
    },
    upSellLabel:{
      "name": "upSellLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "UP-SELL",
        "RECOVER"
      ]
    },
    orderUnit:{
      "name": "orderUnit",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    casePtrLabel:{
      "name": "casePtrLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    packUnitLabel:{
      "name": "packUnitLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    otherUnitLabel:{
      "name": "otherUnitLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    ptrLabel:{
      "name": "ptrLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    orderCheckoutPtrLabel:{
      "name": "orderCheckoutPtrLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    packPtrLabel:{
      "name": "packPtrLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    unitLabel:{
      "name": "unitLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the exact label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    unitVisibility:{
      "name": "unitVisibility",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "Renders in both new and old sku tiles showing the PTR of the product below the sku code component in the right side of the product card. Called from veritical card catalogue",
      "possibleVals": [
        true,
        false
      ]
    },
    suggestedQtyVisibility:{
      "name": "suggestedQtyVisibility",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "it will show suggested qty in product card in catalogue",
      "possibleVals": [
        true,
        false
      ]
    },
    orderSuggestedQty:{
      "name": "orderSuggestedQty",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "it will be the value of suggested qty in product card in catalogue",
      "possibleVals": [
        true,
        false
      ]
    },
    multiUOMSelection:{
      "name": "multiUOMSelection",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "To enable multiple uom selection so that a user is able to add a product in both case quantity as well as piece quantity",
      "possibleVals": [
        true,
        false
      ]
    },
    caseUnitLabel:{
      "name": "caseUnitLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the exact label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },
    defaultCatalogueImage:{
      "name": "defaultCatalogueImage",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "It is the image to be shown when there is no image uploaded for the product or you can say placeholder image.",
      "possibleVals": [
        "string"
      ]
    },
    dummyCouponImage:{
      "name": "dummyCouponImage",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
    dummyItemCouponImage:{
      "name": "dummyItemCouponImage",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
    favouriteSKU:{
      "name": "favouriteSKU",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "Wrapper for the unlikedSKU and likedSKU component . Called from veritical card catalogue.This renders the liked (filled with red color/ or empty) heart component on the top right of the product card.",
      "possibleVals": [
        true,
        false
      ]
    },
    displayPrice:{
      "name": "displayPrice",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "Renders in both new and old sku tiles showing the PTR of the product below the sku code component in the right side of the product card. Called from veritical card catalogue",
      "possibleVals": [
        true,
        false
      ]
    },
    skuCodeCondition:{
      "name": "skuCodeCondition",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
    multiVariantHeader:{
      "name": "multiVariantHeader",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
    skuCodeVisibility:{
      "name": "skuCodeVisibility",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        true,
        false
      ]
    },
    autoUOMConversion:{
      "name": "autoUOMConversion",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "It will convert uom automatically in order.",
      "possibleVals": [
        true,
        false
      ]
    },
    maxDiscountVisibility:{
      "name": "maxDiscountVisibility",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "It will show the max discount",
      "possibleVals": [
        true,
        false
      ]
    },
    maxAllowedDigitForOrder:{
      "name": "maxAllowedDigitForOrder",
      "type": "number",
      "value": 3,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "maxAllowedDigitForOrder",
      "possibleVals": []
    },
    additionalSchemes:{
      "name": "additionalSchemes",
      "type": "boolean",
      "value": false,
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "This is the new offers template that gets rendered from either old or new sku tile . Renders at the bottom of the product card.",
      "possibleVals": [
        true,
        false
      ]
    },
    priceFormatter: {
      name: "priceFormatter",
      type: "string",
      value: "",
      docUrl: "https://applicate.atlassian.net/l/cp/90s18da0",
      description:
        "Tells what format should be used and corresponding handlebar helper runs. Helpers : CapitalizeText , upperCaseValue",
      possibleVals: [],
    },
    locationPopupOnOrder: {
      name: "locationPopupOnOrder",
      type: "boolean",
      value: false,
      docUrl: "https://applicate.atlassian.net/l/cp/90s18da0",
      description: "",
      possibleVals: [true, false],
    },
    pieceSizeVisibility: {
      name: "pieceSizeVisibility",
      type: "boolean",
      value: false,
      docUrl: "https://applicate.atlassian.net/l/cp/90s18da0",
      description: "",
      possibleVals: [true, false],
    },
    pieceSizeLabel: {
      "name": "pieceSizeLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "renders the label that comes from the config",
      "possibleVals": [
        "string"
      ]
    },   
  cataloguePrioritySorting: {
    "name": "cataloguePrioritySorting",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      "string"
    ]
  },
  tabFilterType: {
    "name": "tabFilterType",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      "string"
    ]
  },
  outletLevelPricing: {
    "name": "outletLevelPricing",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true,
      false
    ]
  },

    productTypeFilter: {
      "name": "productTypeFilter",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
  
    sspLabel: {
      "name": "sspLabel",
      "type": "string",
      "value": "",
      "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
      "description": "",
      "possibleVals": [
        "string"
      ]
    },
  enableEditPrice: {
    "name": "enableEditPrice",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true,
      false
    ]
  },
  displayProductValidationFilter: {
    "name": "displayProductValidationFilter",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      "string"
    ]
  },
  displayProductValidation: {
    "name": "displayProductValidation",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true,
      false
    ]
  },
  defaultQtyForOrder: {
    "name": "defaultQtyForOrder",
    "type": "string",
    "value": "",
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      "string"
    ]
  },
  editPricing: {
    "name": "editPricing",
    "type": "boolean",
    "value": false,
    "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
    "description": "",
    "possibleVals": [
      true,
      false
    ]
  }
};

export const defaultCatalogueSortingConfig: defaultCatalogueSortingvalues = {
    catalogueSortingConfig: {
        "name": "catalogueSortingConfig",
        "type": "list",
        "value": [
            
        ],
        "docUrl": "",
        "description": "catalogue sorting config",
        "possibleVals": [
            {
                "id": "packMrp",
                "name": "MRP - Low to High",
                "type": "ascending"
            },
            {
                "id": "packMrp",
                "name": "MRP - High to Low",
                "type": "descending"
            },
            {
                "id": "packPtr",
                "name": "PTR - Low to High",
                "type": "ascending"
            },
            {
                "id": "packPtr",
                "name": "PTR - High to Low",
                "type": "descending"
            }]
    },
}